import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Consumer } from '@app/resources/services';

const sortNonConsumerById = (a: Consumer, b: Consumer) => {
  return a.ConsumerId - b.ConsumerId;
};

export const nonConsumerAdapter: EntityAdapter<Consumer> = createEntityAdapter<Consumer>({
  sortComparer: sortNonConsumerById,
  selectId: (e) => e?.ConsumerId ?? 0,
});

export const {
  selectIds: selectNonConsumerIds,
  selectEntities: selectNonConsumerEntities,
  selectAll: selectAllNonConsumers,
  selectTotal: nonConsumersCount,
} = nonConsumerAdapter.getSelectors();
